const routeConstant = {
  login: "/",
  users: "/users",
  emailVerification: "/email/verify",
  signup: "/signup",
  signupConfirm: "/signup-confirm",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  resetPasswordConfirm: "/confirm-password-reset",
  profile: "/profile",
  changePassword: "/change-password",
  changePasswordConfirm: "/confirm-password-change",
  createProject: "/create-project",
  project: `/project/:id`,
  goToProject: ({ projectId }) => `/project/${projectId}`,
  publicProjectView: ({ projectId }) =>
    `/public/project/${projectId}/:publicId`,
  noProjects: "/no-projects",
  homeMobile: "/home",
  goToMileStone: (id) => `/milestone/${id}`,
  milestoneView: "/milestone/:milestoneId",
  archivedProjects: "/archived",
  notifications: "/notifications",
  projectSettings: `/project/settings/:id`,
  milestoneCreate: (id) => `/project/${id}/milestone`,
  milestoneCreateRoute: `/project/:id/milestone`,
  projectList: "/project-list",
  tnc: "/tnc",
  privacy: "/privacy",
  forbidden: "/forbidden",
};

export default routeConstant;
